<template>
  <div class="pt-4 px-4 pb-20">
    <h1 class="text-3xl font-bold mb-5">
      {{ $t('positions') }}
    </h1>
    <div class="mb-3">
      <div class="">
        <nav class="grid grid-cols-2 space-x-4 mb-5 bg-white rounded-full p-1" :class="[$theme.tabsContainerBg]" aria-label="Tabs">
          <a
              v-for="tab in tabs"
              :key="tab.key"
              href="javascript:void(0)"
              @click="onChangeTab(tab)"
              :class="[
              tab.key === this.activeTab  ? `m-yellow-bg text-black` : `${$theme.tabTextColor}`,
              'rounded-full px-3 py-2 text-sm font-medium text-center'
            ]">
            {{ tab.name }}
            <template v-if="tab.key === 'open'">({{ positions.length }})</template>
          </a>
        </nav>
      </div>
    </div>
    <template v-if="activeTab === 'open'">
      <template v-if="loading">
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
      </template>
      <template v-else>
        <template v-if="positions.length">
          <div v-for="position in positions" :key="position.id" class="mb-3">
            <OrderItem :order="position" :is_edit="true" @close-position="onClosedPosition" />
          </div>
        </template>
        <template v-else>
          <div class="rounded-xl overflow-hidden px-4 py-4" :class="[$theme.cardBg, $theme.borderBlockColor]">
            <p class="text-center opacity-40">{{ $t('no_active_positions') }}</p>
          </div>
        </template>
      </template>
    </template>
    <template v-if="activeTab === 'history'">
      <template v-if="loadingHistory">
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
      </template>
      <template v-else>
        <template v-if="history.data.length">
          <div v-for="order in history.data" :key="order.id" class="mb-3">
            <OrderItem :order="order" />
          </div>
        </template>
        <template v-else>
          <div class="rounded-xl overflow-hidden px-4 py-4" :class="[$theme.cardBg, $theme.borderBlockColor]">
            <p class="text-center">{{ $t('no_history') }}</p>
          </div>
        </template>
        <template v-if="history.meta.last_page > this.historyParams.page">
          <button
              @click="onLoadHistoryMore"
              class="w-full text-sm py-3 rounded-xl font-medium mt-2"
              :class="[
                  loadingHistoryMore ? 'opacity-60 pointer-events-none' : '',
                  $theme.outlineBtnBg,
                  $theme.outlineBtnTextColor,
              ]"
          >
            <template v-if="loadingHistoryMore">
              <ButtonSpinnerBlue />
            </template>
            {{ $t('load_more') }}
          </button>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import OrderItem from "@/components/elem/OrderItem.vue";
import OrderItemPlaceholder from "@/components/placeholders/OrderItemPlaceholder.vue";
import ButtonSpinnerBlue from "@/components/ButtonSpinnerBlue.vue";

export default {
  components: {
    OrderItem,
    ButtonSpinnerBlue,
    OrderItemPlaceholder
  },

  methods: {
    calculateROI(trade) {
      const pnl = parseFloat(trade.pnl);
      const margin = parseFloat(trade.margin);

      if (margin === 0) return 0;

      const roe = (pnl / margin) * 100;
      return Number(roe.toFixed(2));
    },

    onChangeTab(tab) {
      this.activeTab = tab.key;

      if (this.activeTab === 'open') {
        this.loadOpenPositions();
      }

      if (this.activeTab === 'history') {
        this.loadHistoryOrder();
      }
    },

    onClosedPosition() {
      this.loadOpenPositions();

      setTimeout(() => {
        this.loadOpenPositions();
      }, 5000)
    },

    loadOpenPositions() {
      console.log('Load positions...');

      this.$api.get('/positions/opened').then((result) => {
        console.log('Loaded positions', result)
        this.positions = result.data.data;
        this.loading = false

        this.positions.forEach(position => {
          if (position.exchange.exchange_slug === 'whitebit' &&
              !this.websockets.tokens[position.exchange.id]) {
            this.getWhitebitWebsocketToken(position.exchange.id);
          }
        });
      }).catch(e => {
        console.log(e)
        this.error = e
      })
    },

    loadHistoryOrder() {
      console.log('Load history orders...');

      this.loadingHistory = true;

      this.$api.get('/positions', {
        params: this.historyParams
      }).then((result) => {
        console.log(result.data);
        this.history = result.data;
        this.loadingHistory = false;
      }).catch(e => {
        console.log(e)
        this.error = e
      })
    },

    onLoadHistoryMore() {
      this.loadingHistoryMore = true;
      this.historyParams.page += 1;

      this.$api.get('/positions', {
        params: this.historyParams
      }).then((result) => {
        this.history.data = [...this.history.data, ...result.data.data];
        this.loadingHistoryMore = false;
      }).catch(e => {
        console.log(e);
        this.error = e;
      });
    },

    getWhitebitWebsocketToken(exchangeId) {
      this.$api.post('/whitebit/websockets/token', {
        exchange_id: exchangeId,
      }).then((result) => {
        console.log(result.data.token.websocket_token);
        this.websockets.tokens.push({
          exchange_id: exchangeId,
          token: result.data.token.websocket_token
        });
        this.onInitWebsocketWhitebit();
      }).catch(e => {
        console.log(e);
        this.error = e;
      })
    },

    onInitWebsocketWhitebit() {
      this.websockets.tokens.forEach(tokenObj => {
        const exchangeId = tokenObj.exchange_id;

        if (!this.websockets.sockets[exchangeId]) {
          const socket = new WebSocket("wss://api.whitebit.com/ws");

          socket.onopen = () => {
            console.log('WebSocket подключен для exchange', exchangeId);
            socket.send(JSON.stringify({
              id: exchangeId,
              method: "authorize",
              params: [tokenObj.token, "public"]
            }));
          };

          socket.onmessage = (event) => {
            const msg = JSON.parse(event.data);

            if (msg.id === exchangeId && msg.error === null && msg.result.status === 'success') {
              console.log('Авторизация успешна, отправка подписки');
              socket.send(JSON.stringify({
                id: exchangeId + 1,
                method: "positionsMargin_subscribe",
                params: []
              }));
            }

            if (msg.id === exchangeId + 1) {
              if (msg.error === null && msg.result.status === 'success') {
                console.log('Подписка на positionsMargin_subscribe успешна');
              } else {
                console.error('Ошибка подписки:', msg.error);
              }
            }

            if (msg.method === "positionsMargin_update") {
              const positions = msg.params.records;
              let needReload = false;

              positions.forEach((position) => {
                if (!position.id) {
                  return;
                }

                const orderIndex = this.positions.findIndex((o) => {
                  if (!o.position_id) {
                    return false;
                  }
                  return o.position_id.toString() === position.id.toString();
                });

                if (orderIndex > -1) {
                  if (position.amount === "0") {
                    needReload = true;
                  } else {
                    this.positions[orderIndex].unrealized_pnl = position.pnl;
                    this.positions[orderIndex].initial_margin = position.margin;
                    this.positions[orderIndex].percentage = this.calculateROI(position);
                  }
                } else {
                  needReload = true;
                }
              });

              if (needReload) {
                this.loadOpenPositions();
              }
            }
          };

          socket.onerror = (error) => {
            console.error('WebSocket error:', error);
          };

          socket.onclose = () => {
            console.log('WebSocket disconnected');
          };

          // Ping каждые 50 секунд
          const pingInterval = setInterval(() => {
            if (socket.readyState === WebSocket.OPEN) {
              socket.send(JSON.stringify({
                id: 0,
                method: "ping",
                params: [],
              }));
            }
          }, 50000);

          this.websockets.sockets[exchangeId] = {
            socket,
            pingInterval
          };
        }
      });
    },
  },

  data() {
    return {
      loading: true,
      loadingHistory: true,
      loadingHistoryMore: false,
      positions: [],
      history: null,
      error: null,
      activeTab: 'open',
      tabs: [
        { name: this.$t('open'), key: 'open' },
        { name: this.$t('history'), key: 'history' },
      ],
      historyParams: {
        user_id: this.$user.id,
        per_page: 10,
        page: 1
      },

      typeListenKey: 'create',
      listenKey: '',

      intervalId: null,
      pingInterval: null,
      socket: null,

      websockets: {
        tokens: [],
        sockets: {}
      },
      checkOrdersInterval: null,
    }
  },

  mounted() {
    this.loadOpenPositions()

    this.checkOrdersInterval = setInterval(() => {
      if (!this.positions.length) {
        this.loadOpenPositions();
      } else {
        clearInterval(this.checkOrdersInterval);
        this.checkOrdersInterval = null;
      }
    }, 10_000);
  },

  beforeUnmount() {
    if (this.checkOrdersInterval) {
      clearInterval(this.checkOrdersInterval);
      this.checkOrdersInterval = null;
    }

    Object.entries(this.websockets.sockets).forEach(([exchangeId, { socket, pingInterval }]) => {
      console.log('Close socket', exchangeId);
      clearInterval(pingInterval);
      if (socket.readyState === WebSocket.OPEN) socket.close();
    });

    this.websockets.sockets = {};
    this.websockets.tokens = {};
  }
}
</script>
